






























import { ErrorCodes } from '@ringana/errors';
import Vue from 'vue';
import { ICalendarDoor, ICalendarDoorBase } from '@/common/interfaces/announcement-bar.interface';
import CalendarCloseButton from '@/components/announcementbar/christmas-calendar/subcomponents/CalendarCloseButton.vue';
import ChristmasCalendarDesktopView from '@/components/announcementbar/christmas-calendar/subcomponents/ChristmasCalendarDesktopView.vue';
import ChristmasCalendarMobileView from '@/components/announcementbar/christmas-calendar/subcomponents/ChristmasCalendarMobileView.vue';
import InformationOverlay from '@/components/announcementbar/christmas-calendar/subcomponents/InformationOverlay.vue';
import AnnouncementBarHelper from '@/helpers/AnnouncementBarHelper';
import AppHelper from '@/helpers/AppHelper';
import PartnerShopHelper from '@/helpers/page-specific/PartnerShopHelper';
import SessionStorageHelper from '@/helpers/SessionStorageHelper';
import TIcons from '@/types/TIcons';
import { ECalendarDoorTypes } from '@/common/enums/announcement-bar.enum';
import { TEnvironmentName } from '@/common/types/index.types';
import CookieHelper from '@/helpers/CookieHelper';

interface IChristmasCalendarComponent {
  calculateContainerHeightFunction: null | (() => void);
  doorContent: ICalendarDoor | null;
  isPartnerShop: boolean;
  overlay: {
    type: `early` | `late` | null;
    visible: boolean;
  };
  showReadMore: boolean;
}

export default Vue.extend({
  name: `ChristmasCalendar`,
  components: {
    CalendarCloseButton,
    ChristmasCalendarDesktopView,
    ChristmasCalendarMobileView,
    InformationOverlay,
  },
  data(): IChristmasCalendarComponent {
    return {
      calculateContainerHeightFunction: null,
      doorContent: null,
      isPartnerShop: false,
      overlay: {
        type: null,
        visible: false,
      },
      showReadMore: false,
    };
  },
  computed: {
    currentDay(): number {
      const environmentName: TEnvironmentName = AppHelper.getEnvironmentName();
      return (environmentName === `production` || environmentName === `staging`) ? new Date().getDate() : 10;
    },
    currentDayIdForMobile(): number {
      return this.doors[this.currentDay - 1].id;
    },
    isGiveawayDoorSelected(): boolean {
      return this.doorContent?.type === ECalendarDoorTypes.GIVEAWAY;
    },
    logoPath(): string {
      return PartnerShopHelper.isPageInPartnerShop() ? TIcons.ringanaLogoPartner : TIcons.ringanaLogo;
    },
  },
  props: {
    barHeight: {
      default: 0,
      type: Number,
    },
    doors: {
      required: true,
      type: Array as () => ICalendarDoorBase[],
    },
    visible: {
      default: false,
      type: Boolean,
    },
  },
  mounted(): void {
    window.addEventListener(`keyup`, this.onKeyUp);
    SessionStorageHelper.setChristmasCalendarSeen();
  },
  beforeDestroy(): void {
    if(typeof this.calculateContainerHeightFunction === `function`) {
      window.removeEventListener(`resize`, this.calculateContainerHeightFunction);
    }
    window.removeEventListener(`keyup`, this.onKeyUp);
  },
  methods: {
    closeCalendar(): void {
      this.closeOverlay();
      this.$emit(`close:calendar`);
      this.doorContent = null;
      this.showReadMore = false;
    },
    closeOverlay(): void {
      this.overlay = {
        type: null,
        visible: false,
      };
    },
    onKeyUp(event: KeyboardEvent): void {
      if(event.code === `Escape`) {
        this.closeCalendar();
      }
    },
    async openSelectedCircle(doorId: number): Promise<void> {
      try {
        const deliveryAddressIso = CookieHelper.getDeliveryAddressIso() || undefined;
        this.doorContent = AnnouncementBarHelper.transformApiCalendarDoorToCalendarDoor(await this.$abApiService.getDoorById(doorId, deliveryAddressIso));
      } catch (err) {
        const errorCode = (err as { info?: { errorCode?: ErrorCodes } })?.info?.errorCode;
        if(errorCode) {
          switch(errorCode) {
            case ErrorCodes.ANNOUNCEMENT_CALENDAR_DOOR_TOO_EARLY:
              this.overlay = {
                type: `early`,
                visible: true,
              };
              break;
            case ErrorCodes.ANNOUNCEMENT_CALENDAR_DOOR_TOO_LATE:
              this.overlay = {
                type: `late`,
                visible: true,
              };
              break;
            default:
              throw err;
          }
        } else {
          throw err;
        }
      }
    },
  },
});
